import { Link } from "@tanstack/react-router"
import { cn } from "@/lib/utils"

type EmptyStateAction = { label: string; emphasis?: boolean } & (
  | { onClick: () => void; to?: never }
  | { to: string; onClick?: never }
)

/**
 * The one empty-state block. `dashed` is the bordered py-12 card used on
 * list pages; `plain` is the single muted line used on admin/panel surfaces.
 */
export function EmptyState({
  variant = "dashed",
  title,
  description,
  action,
  className,
}: {
  variant?: "dashed" | "plain"
  title: string
  description?: React.ReactNode
  action?: EmptyStateAction
  className?: string
}) {
  if (variant === "plain") {
    return (
      <p className={cn("text-sm text-[color:var(--wf-mute)]", className)}>
        {title}
      </p>
    )
  }
  return (
    <div
      className={cn(
        "border border-dashed border-[rgb(12_15_20/0.12)] py-12 text-center",
        className,
      )}
    >
      <p className="text-[color:var(--wf-mute)]">{title}</p>
      {description && (
        <p className="mt-1 text-sm text-[color:var(--wf-mute)]">{description}</p>
      )}
      {action &&
        (action.to != null ? (
          <Link
            to={action.to}
            className={cn(
              "home-wf-btn mt-4 inline-flex",
              action.emphasis ? "home-wf-btn--lime" : "home-wf-btn--outline",
            )}
          >
            {action.label}
          </Link>
        ) : (
          <button
            type="button"
            className={cn(
              "home-wf-btn mt-4",
              action.emphasis ? "home-wf-btn--lime" : "home-wf-btn--outline",
            )}
            onClick={action.onClick}
          >
            {action.label}
          </button>
        ))}
    </div>
  )
}
